<script lang="ts" setup>
  import { tr } from '~/assets/scripts/helpers'

  defineProps({
    message: { type: String, required: false, default: 'Loading' },
  })
</script>

<template>
  <div class="d-flex flex-column align-items-center">
    <div class="loader-container">
      <div class="loading-indicator">
        <div />
        <div />
        <div />
      </div>
    </div>
    <div class="text-center">
      {{ message ? tr(message) : `&nbsp;` }}
    </div>
  </div>
</template>

<style scoped>
  .loader-container {
    width: 70px;
  }

  .loading-indicator {
    display: inline-block;
    position: relative;
    width: 60px;
    height: 50px;
  }

  .loading-indicator div {
    display: inline-block;
    position: absolute;
    left: 8px;
    width: 14px;
    background: #585c63;
    animation: loading-indicator 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }

  .loading-indicator div:nth-child(1) {
    left: 7px;
    animation-delay: -0.24s;
  }

  .loading-indicator div:nth-child(2) {
    left: 28px;
    animation-delay: -0.12s;
  }

  .loading-indicator div:nth-child(3) {
    left: 49px;
    animation-delay: 0ms;
  }

  @keyframes loading-indicator {
    0% {
      top: 2px;
      height: 56px;
    }
    50%,
    100% {
      top: 16px;
      height: 28px;
    }
  }
</style>
